var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 47,
    viewBox: "0 0 30 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8968 45.3234H2.99206C1.89188 45.3234 1 44.4315 1 43.3314V38.8492V7.47421V2.99206C1 1.89188 1.89187 1 2.99206 1H26.8968C27.997 1 28.8889 1.89188 28.8889 2.99206V7.47421V38.8492V43.3313C28.8889 44.4315 27.997 45.3234 26.8968 45.3234Z",
    stroke: "#4A4D52",
    strokeWidth: 1.99206
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 9,
    fill: "#4A4D52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5L13.5 15L19.5 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 25.5H23",
    stroke: "#4A4D52",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31H23",
    stroke: "#4A4D52",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 36.5H23",
    stroke: "#4A4D52",
    strokeWidth: 3,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.253d25b07d130918ed1058df58a8d090.svg";
export { ForwardRef as ReactComponent };